import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LanguageState } from "../interfaces/language.interface";

interface LanguagePayload {
  language: string;
}

const initialState: LanguageState = {
  currentLanguage: "en",
  isInitialized: false,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguagePayload>) => {
      state.currentLanguage = action.payload.language;
      state.isInitialized = true;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
